import { request as baseRequest, BaseRequestOptions } from '@community_dev/requests'

import { AUTH_TOKENS } from 'constants/web-storage'

export function getBaseUrl(url: string | undefined = import.meta.env.VITE_API_URL): string {
  return url === 'undefined' || !url ? '' : url
}

type RequestOptions = BaseRequestOptions & {
  baseUrl?: string
  noAuth?: boolean
  skipAuthCheck?: boolean
  token?: string
}

export async function request(path: string, options: RequestOptions = {}): Promise<any> {
  const { baseUrl, noAuth, skipAuthCheck, ...fetchOptions } = options
  const token = options.token || (!noAuth && sessionStorage.getItem(AUTH_TOKENS))
  const headers = {
    ...(!noAuth && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  }

  return baseRequest(`${getBaseUrl(baseUrl)}${path}`, {
    ...fetchOptions,
    headers,
  })
}
